export default __webpack_public_path__ + "static/media/listbuilder-bug-selected.2fee7435.svg";